var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "flmdashboard"
  }, [_c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "margin-bottom": "3px",
      "font-size": "18px"
    }
  }, [_vm._v("\n          Last refreshed : " + _vm._s(_vm.lastrefreshed) + " "), _c('i', {
    staticClass: "icon-refresh",
    staticStyle: {
      "font-weight": "900"
    },
    on: {
      "click": _vm.manualrefresh
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[1]),
      expression: "accordianTab[1]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "Pending",
      "id": "chck1"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[1]) ? _vm._i(_vm.accordianTab[1], null) > -1 : (_vm.accordianTab[1])
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.accordianTab[1],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[1] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[1] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 1, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck1"
    }
  }, [_vm._v("Overview")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "main-part"
  }, [_c('div', {
    staticClass: "cpanel cpanel-black"
  }, [_c('div', {
    staticClass: "icon-part"
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true",
      "title": "Trips created - Number of trips created but not started."
    }
  }), _c('br'), _vm._v(" "), _c('small', [_vm._v("Trips Created")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.pendingforclosuer.tripcreated))])]), _vm._v(" "), _c('div', {
    staticClass: "card-content-part"
  }, [_c('p', {
    attrs: {
      "title": "Click here"
    },
    on: {
      "click": function($event) {
        _vm.openMoreDetailsCount('tripdata', 'created')
      }
    }
  }, [_vm._v("More Details")])])]), _vm._v(" "), _c('div', {
    staticClass: "cpanel cpanel-green"
  }, [_c('div', {
    staticClass: "icon-part"
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true",
      "title": "Trips started - Number of new trips started."
    }
  }), _c('br'), _vm._v(" "), _c('small', [_vm._v("Trips Started")]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(_vm.pendingforclosuer.tripstarted))])]), _vm._v(" "), _c('div', {
    staticClass: "card-content-part"
  }, [_c('p', {
    attrs: {
      "title": "Click here"
    },
    on: {
      "click": function($event) {
        _vm.openMoreDetailsCount('tripdata', 'start')
      }
    }
  }, [_vm._v("More Details")])])]), _vm._v(" "), _c('div', {
    staticClass: "cpanel cpanel-blue"
  }, [_c('div', {
    staticClass: "icon-part"
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true",
      "title": "Trips closed - Number of trips closed."
    }
  }), _c('br'), _vm._v(" "), _c('small'), _vm._v(" "), _c('small', [_vm._v("Trips closed")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.pendingforclosuer.closed))])]), _vm._v(" "), _c('div', {
    staticClass: "card-content-part"
  }, [_c('p', {
    attrs: {
      "title": "Click here"
    },
    on: {
      "click": function($event) {
        _vm.openMoreDetailsCount('tripdata', 'closed')
      }
    }
  }, [_vm._v("More Details")])])]), _vm._v(" "), _c('div', {
    staticClass: "cpanel cpanel-darkviolate"
  }, [_c('div', {
    staticClass: "icon-part"
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true",
      "title": "OFP - Number of AWB out for pickup(OFP)."
    }
  }), _c('br'), _vm._v(" "), _c('small'), _vm._v(" "), _c('small', [_vm._v("OFP")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.pendingforclosuer.ofp))])]), _vm._v(" "), _c('div', {
    staticClass: "card-content-part"
  }, [_c('p', {
    attrs: {
      "title": "Click here"
    },
    on: {
      "click": function($event) {
        _vm.openMoreDetailsCount('awbdata', 'ofp')
      }
    }
  }, [_vm._v("More Details")])])])]), _vm._v(" "), _c('div', {
    staticClass: "main-part"
  }, [_c('div', {
    staticClass: "cpanel cpanel-darkviolate"
  }, [_c('div', {
    staticClass: "icon-part"
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true",
      "title": "OFD - Number of AWB out for delivery (OFD)."
    }
  }), _c('br'), _vm._v(" "), _c('small'), _vm._v(" "), _c('small', [_vm._v("OFD")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.pendingforclosuer.ofd))])]), _vm._v(" "), _c('div', {
    staticClass: "card-content-part"
  }, [_c('p', {
    attrs: {
      "title": "Click here"
    },
    on: {
      "click": function($event) {
        _vm.openMoreDetailsCount('awbdata', 'ofd')
      }
    }
  }, [_vm._v("More Details")])])]), _vm._v(" "), _c('div', {
    staticClass: "cpanel cpanel-lightblue"
  }, [_c('div', {
    staticClass: "icon-part"
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true",
      "title": "FM Picked - Number of FM picked."
    }
  }), _c('br'), _vm._v(" "), _c('small'), _vm._v(" "), _c('small', [_vm._v("FM Picked")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.pendingforclosuer.picked))])]), _vm._v(" "), _c('div', {
    staticClass: "card-content-part"
  }, [_c('p', {
    attrs: {
      "title": "Click here"
    },
    on: {
      "click": function($event) {
        _vm.openMoreDetailsCount('awbdata', 'picked')
      }
    }
  }, [_vm._v("More Details")])])]), _vm._v(" "), _c('div', {
    staticClass: "cpanel cpanel-red"
  }, [_c('div', {
    staticClass: "icon-part"
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true",
      "title": "LM Delivered - Number of LM delivered."
    }
  }), _c('br'), _vm._v(" "), _c('small'), _vm._v(" "), _c('small', [_vm._v("LM Delivered")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.pendingforclosuer.delivered))])]), _vm._v(" "), _c('div', {
    staticClass: "card-content-part"
  }, [_c('p', {
    attrs: {
      "title": "Click here"
    },
    on: {
      "click": function($event) {
        _vm.openMoreDetailsCount('awbdata', 'delivered')
      }
    }
  }, [_vm._v("More Details")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[2]),
      expression: "accordianTab[2]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "Today",
      "id": "chck2"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[2]) ? _vm._i(_vm.accordianTab[2], null) > -1 : (_vm.accordianTab[2])
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.accordianTab[2],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[2] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[2] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 2, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck2"
    }
  }, [_vm._v("Today's Performance")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "main-part"
  }, [_c('div', {
    staticClass: "cpanel cpanel-black"
  }, [_c('div', {
    staticClass: "icon-part"
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true",
      "title": "Trips created - Number of trips created but not started."
    }
  }), _c('br'), _vm._v(" "), _c('small', [_vm._v("Trip Created")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.todayperformance.tripcreated))])]), _vm._v(" "), _c('div', {
    staticClass: "card-content-part"
  }, [_c('p', {
    attrs: {
      "title": "Click here"
    },
    on: {
      "click": function($event) {
        _vm.openMoreDetailsCount('todaytripdata', 'created')
      }
    }
  }, [_vm._v("More Details")])])]), _vm._v(" "), _c('div', {
    staticClass: "cpanel cpanel-green"
  }, [_c('div', {
    staticClass: "icon-part"
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true",
      "title": "Trips started - Number of new trips started."
    }
  }), _c('br'), _vm._v(" "), _c('small', [_vm._v("Trip Start")]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(_vm.todayperformance.tripstart))])]), _vm._v(" "), _c('div', {
    staticClass: "card-content-part"
  }, [_c('p', {
    attrs: {
      "title": "Click here"
    },
    on: {
      "click": function($event) {
        _vm.openMoreDetailsCount('todaytripdata', 'start')
      }
    }
  }, [_vm._v("More Details")])])]), _vm._v(" "), _c('div', {
    staticClass: "cpanel cpanel-orange"
  }, [_c('div', {
    staticClass: "icon-part"
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true",
      "title": "Trips closed - Number of trips closed."
    }
  }), _c('br'), _vm._v(" "), _c('small', [_vm._v("Trip Close")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.todayperformance.tripclose))])]), _vm._v(" "), _c('div', {
    staticClass: "card-content-part"
  }, [_c('p', {
    attrs: {
      "title": "Click here"
    },
    on: {
      "click": function($event) {
        _vm.openMoreDetailsCount('todaytripdata', 'closed')
      }
    }
  }, [_vm._v("More Details")])])]), _vm._v(" "), _c('div', {
    staticClass: "cpanel cpanel-orange"
  }, [_c('div', {
    staticClass: "icon-part"
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true",
      "title": "Trips Pending Closure - Number of trips not closed."
    }
  }), _c('br'), _vm._v(" "), _c('small', [_vm._v("Trip Pending Closure")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.todayperformance.pendingforclosure))])]), _vm._v(" "), _c('div', {
    staticClass: "card-content-part"
  }, [_c('p', {
    attrs: {
      "title": "Click here"
    },
    on: {
      "click": function($event) {
        _vm.openMoreDetailsCount('todaytripdata', 'pendingclosure')
      }
    }
  }, [_vm._v("More Details")])])])]), _vm._v(" "), _c('div', {
    staticClass: "main-part"
  }, [_c('div', {
    staticClass: "cpanel cpanel-lightblue"
  }, [_c('div', {
    staticClass: "icon-part"
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true",
      "title": "FM allocation - Number of AWBs allocated to FM trips."
    }
  }), _c('br'), _vm._v(" "), _c('small', [_vm._v("FM Allocation")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.todayperformance.fmallocation))])]), _vm._v(" "), _c('div', {
    staticClass: "card-content-part"
  }, [_c('p', {
    attrs: {
      "title": "Click here"
    },
    on: {
      "click": function($event) {
        _vm.openMoreDetailsCount('todayallocation', 'firstmile')
      }
    }
  }, [_vm._v("More Details")])])]), _vm._v(" "), _c('div', {
    staticClass: "cpanel cpanel-blue"
  }, [_c('div', {
    staticClass: "icon-part"
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true",
      "title": "FM OFP - Number of AWBs with status OFP."
    }
  }), _c('br'), _vm._v(" "), _c('small', [_vm._v("FM OFP")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.todayperformance.fmofp))])]), _vm._v(" "), _c('div', {
    staticClass: "card-content-part"
  }, [_c('p', {
    attrs: {
      "title": "Click here"
    },
    on: {
      "click": function($event) {
        _vm.openMoreDetailsCount('todayawbdata', 'ofp')
      }
    }
  }, [_vm._v("More Details")])])]), _vm._v(" "), _c('div', {
    staticClass: "cpanel cpanel-red"
  }, [_c('div', {
    staticClass: "icon-part"
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true",
      "title": "FM Picked  - Number of AWBs with status picked."
    }
  }), _c('br'), _vm._v(" "), _c('small', [_vm._v("FM Picked")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.todayperformance.fmpicked))])]), _vm._v(" "), _c('div', {
    staticClass: "card-content-part"
  }, [_c('p', {
    attrs: {
      "title": "Click here"
    },
    on: {
      "click": function($event) {
        _vm.openMoreDetailsCount('todayawbdata', 'picked')
      }
    }
  }, [_vm._v("More Details")])])]), _vm._v(" "), _c('div', {
    staticClass: "cpanel cpanel-skyblue"
  }, [_c('div', {
    staticClass: "icon-part"
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true",
      "title": "FM NPR - Number of AWBs with status NPR."
    }
  }), _c('br'), _vm._v(" "), _c('small', [_vm._v("FM NPR")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.todayperformance.fmnpr))])]), _vm._v(" "), _c('div', {
    staticClass: "card-content-part"
  }, [_c('p', {
    attrs: {
      "title": "Click here"
    },
    on: {
      "click": function($event) {
        _vm.openMoreDetailsCount('todayawbdata', 'unpicked')
      }
    }
  }, [_vm._v("More Details")])])])]), _vm._v(" "), _c('div', {
    staticClass: "main-part"
  }, [_c('div', {
    staticClass: "cpanel cpanel-brown"
  }, [_c('div', {
    staticClass: "icon-part"
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true",
      "title": "LM allocation - Number of AWBs allocated to LM trips."
    }
  }), _c('br'), _vm._v(" "), _c('small', [_vm._v("LM Allocation")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.todayperformance.lmallocation))])]), _vm._v(" "), _c('div', {
    staticClass: "card-content-part"
  }, [_c('p', {
    attrs: {
      "title": "Click here"
    },
    on: {
      "click": function($event) {
        _vm.openMoreDetailsCount('todayallocation', 'lastmile')
      }
    }
  }, [_vm._v("More Details")])])]), _vm._v(" "), _c('div', {
    staticClass: "cpanel cpanel-darkviolate"
  }, [_c('div', {
    staticClass: "icon-part"
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true",
      "title": "LM OFD- Number of AWBs with status OFD."
    }
  }), _c('br'), _vm._v(" "), _c('small', [_vm._v("LM OFD")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.todayperformance.lmofd))])]), _vm._v(" "), _c('div', {
    staticClass: "card-content-part"
  }, [_c('p', {
    attrs: {
      "title": "Click here"
    },
    on: {
      "click": function($event) {
        _vm.openMoreDetailsCount('todayawbdata', 'ofd')
      }
    }
  }, [_vm._v("More Details")])])]), _vm._v(" "), _c('div', {
    staticClass: "cpanel cpanel-pinkshade"
  }, [_c('div', {
    staticClass: "icon-part"
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true",
      "title": "LM Delivered - Number of AWBs with status delivered."
    }
  }), _c('br'), _vm._v(" "), _c('small', [_vm._v("LM\n                  Delivered")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.todayperformance.fmdelivered))])]), _vm._v(" "), _c('div', {
    staticClass: "card-content-part"
  }, [_c('p', {
    attrs: {
      "title": "Click here"
    },
    on: {
      "click": function($event) {
        _vm.openMoreDetailsCount('todayawbdata', 'delivered')
      }
    }
  }, [_vm._v("More Details")])])]), _vm._v(" "), _c('div', {
    staticClass: "cpanel cpanel-blueshade"
  }, [_c('div', {
    staticClass: "icon-part"
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true",
      "title": "LM NDR - Number of AWBs with status NDR."
    }
  }), _c('br'), _vm._v(" "), _c('small', [_vm._v("LM\n                  NDR")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.todayperformance.lmndr))])]), _vm._v(" "), _c('div', {
    staticClass: "card-content-part"
  }, [_c('p', {
    attrs: {
      "title": "Click here"
    },
    on: {
      "click": function($event) {
        _vm.openMoreDetailsCount('todayawbdata', 'undelivered')
      }
    }
  }, [_vm._v("More Details")])])])])])]), _vm._v(" "), (_vm.userflag) ? _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[3]),
      expression: "accordianTab[3]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "PODData",
      "id": "chck3"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[3]) ? _vm._i(_vm.accordianTab[3], null) > -1 : (_vm.accordianTab[3])
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.accordianTab[3],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[3] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[3] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 3, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck3"
    }
  }, [_vm._v("POD Performance")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "main-part"
  }, [_c('div', {
    staticClass: "cpanel cpanel-lightblue"
  }, [_c('div', {
    staticClass: "icon-part"
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true",
      "title": "FM Bad POD - View the bad POD."
    }
  }), _c('br'), _vm._v(" "), _c('small', [_vm._v("FM Bad POD")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.podperformance.firstmilebadpod))])]), _vm._v(" "), _c('div', {
    staticClass: "card-content-part"
  }, [_c('p', {
    attrs: {
      "title": "Click here"
    },
    on: {
      "click": function($event) {
        _vm.openMoreDetailsCount('badpoddata', 'firstmilepod')
      }
    }
  }, [_vm._v("More Details")])])]), _vm._v(" "), _c('div', {
    staticClass: "cpanel cpanel-orange"
  }, [_c('div', {
    staticClass: "icon-part"
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true",
      "title": "LM Bad POD - Upload POD again."
    }
  }), _c('br'), _vm._v(" "), _c('small', [_vm._v("LM Bad POD")]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(_vm.podperformance.lastmilebadpod))])]), _vm._v(" "), _c('div', {
    staticClass: "card-content-part"
  }, [_c('p', {
    attrs: {
      "title": "Click here"
    },
    on: {
      "click": function($event) {
        _vm.openMoreDetailsCount('badpoddata', 'lastmilepod')
      }
    }
  }, [_vm._v("More Details")])])])])])]) : _vm._e()])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "no-close-on-esc": true,
      "no-close-on-backdrop": true,
      "hide-header-close": true
    },
    on: {
      "ok": function($event) {
        _vm.Moredetailscount = false
      }
    },
    model: {
      value: (_vm.Moredetailscount),
      callback: function($$v) {
        _vm.Moredetailscount = $$v
      },
      expression: "Moredetailscount"
    }
  }, [(_vm.showAWB == false) ? _c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v(_vm._s(_vm.moredetails))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(" - " + _vm._s(_vm.nextcouseaction))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeMoreDetails
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "type": "button",
      "id": "redirectbutton",
      "title": _vm.redirectTitle
    },
    on: {
      "click": _vm.redirectTriplisting
    }
  }, [_vm._v("Redirect "), _c('i', {
    staticClass: "fa fa-exchange",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _c('fieldset', [_c('custom-expandable-table', {
    attrs: {
      "columns": _vm.tableColumn,
      "items": _vm.tableItems,
      "isViewHidden": true,
      "offset": _vm.offset,
      "sorting": _vm.sorting
    },
    on: {
      "customTableEvent": _vm.getCustomTableEvent
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalCount,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.showAWB) ? _c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v(_vm._s(_vm.moredetails))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(" - " + _vm._s(_vm.nextcouseaction))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeMoreDetailsPartialAWB
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("Bad POD count for partial delivered AWB")])]), _vm._v(" "), _c('fieldset', [_c('custom-expandable-table', {
    attrs: {
      "columns": _vm.tableColumn,
      "items": _vm.tableItemspartialawb,
      "isViewHidden": true,
      "offset": 0,
      "sorting": _vm.sorting
    },
    on: {
      "customTableEvent": _vm.getCustomTableEvent
    }
  }), _vm._v(" "), _c('br')], 1)]) : _vm._e()], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-776165e0","hasScoped":true}!./src/modules/firstAndLastmilemanagement/views/flmdashboard/flmdashboard.component.html
// module id = 1922
// module chunks = 3